import autoplayModel from "../../model/AutoplayModel";
import { ICondition } from "../State";

export class HasAutoplayCondition implements ICondition {
    public check(): boolean {
        return  autoplayModel.isAutoSpinActive();
    }
}